// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BhXV","head":"Table_head__xr904","col":"Table_col__e6ehF"};